export enum LoadProfileEnum {
  PV_WATTS_API = 'PV_WATTS_API',
}
